import React, { useMemo, useState } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

interface SearchContextValue {
  /** Whether the header search is shown - set once the page's own search scrolls away. */
  isSearchShown: boolean;
  setIsSearchShown(isShown: boolean): void;
}

/* no-op by default, so pages render the same outside a host that tracks it */
const SearchContext = React.createContext<SearchContextValue>({
  isSearchShown: false,
  setIsSearchShown: () => {},
});

export const SearchContextProvider: FunctionComponent<{
  children: ReactNode;
}> = ({ children }) => {
  const [isSearchShown, setIsSearchShown] = useState(false);
  const value = useMemo(
    () => ({ isSearchShown, setIsSearchShown }),
    [isSearchShown],
  );

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
};

export const useSearch = () => React.useContext(SearchContext);
